<div *ngIf="!validating">
  <app-not-found *ngIf="!validToken"></app-not-found>
  <div *ngIf="validToken" class="container clearfix mt-4">
    <div [hidden]="forgotPassword">
      <h4 class="text-center">
        <div class="row">
          <div class="col-3"></div>
          <div class="col-6">{{ getRegistrationTitle() | translate}}</div>
        </div>
      </h4>
    </div>
    <div [hidden]="!forgotPassword">
      <h4 class="text-center">{{ 'CHANGE-PASSWORD-TITLE' | translate}}</h4>
    </div>
    <br />
    <div class="col-sm-8 col-md-6 col-lg-6 col-xl-5 mx-auto" [hidden]="forgotPassword">
      <div *ngIf="qrCodeDisplayImage">
        <div *ngIf="qrCodeImageUrl" class="text-center">
          <img alt="{{'QRCODE' | translate}}" class="qrcode-image m-2" [src]="qrCodeImageUrl">
        </div>
        <div class="text-center">
          <div class="montserrat mb-3">{{qrCodeKey}}</div>
        </div>
        <div class="text-center text-nowrap mt-4">
          <button kendoButton type="button" class="m-2" (click)="redirectToLogin()">
            {{ 'LOGIN' | translate}}
          </button>
        </div>
        <div class="text-center montserrat row mt-2" *ngIf="allowAlternativeTwoStepAuth">
          <div class="col-12">{{ 'ALTERNATIVE-TWO-STEP-AUTH' | translate}}</div>
        </div>
      </div>
      <form *ngIf="!qrCodeDisplayImage" [formGroup]="userForm" class="k-form">
        <div class="row">
          <div class="col w-100">
            <label class="k-form-field">
              <span class="k-text-uppercase dark">
                {{'USERNAME' | translate}} *
              </span>
              <input id="username" kendoTextBox formControlName="username" maxlength="{{maxUsernameLength}}"
                autocomplete="off" />
              <div class="k-tooltip k-tooltip-validation" role="alert"
                *ngIf="username.hasError('required') && (username.dirty || username.touched)">
                {{'REQUIRED-USERNAME' | translate}}
              </div>
              <div class="k-tooltip k-tooltip-validation" role="alert"
                *ngIf="username.hasError('minlength') && (username.dirty || username.touched)">
                <span translate [translateParams]="{value: minUsernameLength}">{{'USERNAME-MIN-LENGTH'}}</span>
              </div>
              <div class="k-tooltip k-tooltip-validation" role="alert"
                *ngIf="username.hasError('pattern') && !username.hasError('minlength') && (username.dirty || username.touched)">
                {{'USERNAME-INVALID-PATTERN' | translate}}
              </div>
              <div class="k-tooltip k-tooltip-validation" role="alert" *ngIf="username.hasError('usernameTaken')">
                {{'USERNAME-ALREADY-EXISTS' | translate}}
              </div>
            </label>
          </div>
        </div>
        <div class="row">
          <div class="col w-100">
            <label class="k-form-field">
              <span class="k-text-uppercase dark">
                {{'PASSWORD' | translate}} *
              </span>
              <input id="password" type="password" kendoTextBox formControlName="password"
                maxlength="{{maxPasswordLength}}" autocomplete="new-password" />
              <div class="k-tooltip k-tooltip-validation" role="alert"
                *ngIf="password.hasError('required') && (password.dirty || password.touched)">
                {{'REQUIRED-PASSWORD' | translate}}
              </div>
              <div class="k-tooltip k-tooltip-validation" role="alert"
                *ngIf="password.hasError('pattern') && !password.hasError('minlength') && (password.dirty || password.touched)">
                {{invalidPasswordText}}
              </div>
              <div class="k-tooltip k-tooltip-validation" role="alert"
                *ngIf="password.hasError('minlength') && (password.dirty || password.touched)">
                <span translate [translateParams]="{value: minPasswordLength}">{{'PASSWORD-MIN-LENGTH'}}</span>
              </div>
              <password-strength-meter *ngIf="password.value" [password]="password.value"
                [colors]="passwordMeterColors">
              </password-strength-meter>
            </label>
          </div>
        </div>
        <div class="row">
          <div class="col w-100">
            <label class="k-form-field">
              <span class="k-text-uppercase dark">
                {{'PASSWORD-CONFIRM' | translate}} *
              </span>
              <input id="passwordConfirm" type="password" kendoTextBox formControlName="passwordConfirm"
                maxlength="{{maxPasswordLength}}" autocomplete="new-password" />
              <div class="k-tooltip k-tooltip-validation" role="alert"
                *ngIf="passwordConfirm.hasError('required') && (passwordConfirm.dirty || passwordConfirm.touched)">
                {{'REQUIRED-CONFIRM-PASSWORD' | translate}}
              </div>
              <div class="k-tooltip k-tooltip-validation" role="alert"
                *ngIf="passwordConfirm.hasError('unmatchConfirmPassword') && (passwordConfirm.dirty || passwordConfirm.touched)">
                {{'CONFIRM-PASSWORD-NOT-MATCH' | translate}}
              </div>
            </label>
          </div>
        </div>
        <div class="text-center text-nowrap mt-4">
          <button kendoButton type="button" class="m-2" [disabled]="!formValid() || !formDirty()" (click)="register()">
            {{ 'USER-REGISTER-BTN' | translate}}
          </button>
        </div>
      </form>
    </div>
    <div class="col-sm-8 col-md-6 col-lg-6 col-xl-5 mx-auto" [hidden]="!forgotPassword">
      <form [formGroup]="forgotPasswordForm" class="k-form">
        <div class="row">
          <div class="col w-100">
            <label class="k-form-field">
              <span class="k-text-uppercase dark">
                {{'PASSWORD' | translate}} *
              </span>
              <input id="passwordReset" type="password" kendoTextBox formControlName="passwordReset"
                maxlength="{{maxPasswordLength}}" autocomplete="new-password" />
              <div class="k-tooltip k-tooltip-validation" role="alert"
                *ngIf="passwordReset.hasError('required') && (passwordReset.dirty || passwordReset.touched)">
                {{'REQUIRED-PASSWORD' | translate}}
              </div>
              <div class="k-tooltip k-tooltip-validation" role="alert"
                *ngIf="passwordReset.hasError('pattern') && !passwordReset.hasError('minlength') && (passwordReset.dirty || passwordReset.touched)">
                {{invalidPasswordText}}
              </div>
              <div class="k-tooltip k-tooltip-validation" role="alert"
                *ngIf="passwordReset.hasError('minlength') && (passwordReset.dirty || passwordReset.touched)">
                <span translate [translateParams]="{value: minPasswordLength}">{{'PASSWORD-MIN-LENGTH'}}</span>
              </div>
              <password-strength-meter *ngIf="password.value" [password]="password.value"
                [colors]="passwordMeterColors">
              </password-strength-meter>
            </label>
          </div>
        </div>
        <div class="row">
          <div class="col w-100">
            <label class="k-form-field">
              <span class="k-text-uppercase dark">
                {{'PASSWORD-CONFIRM' | translate}} *
              </span>
              <input id="passwordResetConfirm" type="password" kendoTextBox formControlName="passwordResetConfirm"
                maxlength="{{maxPasswordLength}}" autocomplete="new-password" />
              <div class="k-tooltip k-tooltip-validation" role="alert"
                *ngIf="passwordResetConfirm.hasError('required') && (passwordResetConfirm.dirty || passwordResetConfirm.touched)">
                {{'REQUIRED-CONFIRM-PASSWORD' | translate}}
              </div>
              <div class="k-tooltip k-tooltip-validation" role="alert"
                *ngIf="passwordResetConfirm.hasError('unmatchConfirmPassword') && (passwordResetConfirm.dirty || passwordResetConfirm.touched)">
                {{'CONFIRM-PASSWORD-NOT-MATCH' | translate}}
              </div>
            </label>
          </div>
        </div>
        <div class="text-center text-nowrap mt-4">
          <button appPreventClick kendoButton type="button" class="m-2" (click)="redirectToLogin()">
            {{ 'CANCEL' | translate}}
          </button>
          <button appPreventClick kendoButton type="button" class="m-2"
            [disabled]="!forgotPasswordFormValid() || !forgotPasswordFormDirty()" (click)="resetPassword()">
            {{ 'SAVE-NEW-PASSWORD' | translate}}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>